import React from "react";
import HeroV2 from "@/components/Common/HeroV2";
import MeetOurTeam from "@/components/AboutUs/MeetOurTeam";
import Location from "@/components/AboutUs/Location";
import Awards from "@/components/AboutUs/Awards";
import History from "@/components/AboutUs/History";
import { createClient } from "../../prismicio";
import Metadata from "@/components/Metadata";
import Layout from "@/components/Layout";
import Breadcrumbs from "@/components/Common/Breadcrumbs";

const AboutUs = ({ page, globals }) => {
  const pageData = page?.data;
  const commonComponents = globals?.data;

  const team = {
    title: pageData?.title,
    team: pageData?.team,
  };

  const aword = {
    title: pageData?.awards_title,
    awards: pageData?.awards,
  };

  const history = {
    title: pageData?.history_title,
    desc: pageData?.history_description,
    img_1: pageData?.top_right_image,
    desc_2: pageData?.bottom_right_description,
    img_2: pageData?.bottom_left_image,
  };

  return (
    <Layout data={commonComponents}>
      <Metadata
        title={pageData?.metadata_title}
        description={pageData?.metadata_desc}
        image={pageData?.metadata_image?.url}
        path="/about-us"
      />
      <HeroV2
        caption={pageData?.hero_caption}
        title={pageData?.hero_title}
        description={pageData?.hero_description}
        viewMore={true}
        backgroundImage={pageData?.hero_background_image}
        backgroundImageAlt={pageData?.hero_background_image.alt}
        page={"About us"}
      />
      <Breadcrumbs />
      <MeetOurTeam data={team} />
      <Location />
      <Awards data={aword} />
      <History data={history} />
    </Layout>
  );
};

export default AboutUs;

export async function getStaticProps({ previewData }) {
  const client = createClient({ previewData });

  const page = await client.getSingle("about_us_page");
  const globals = await client.getSingle("globals");

  return {
    props: {
      page,
      globals,
    },
  };
}
